import { createSlice } from "@reduxjs/toolkit";
import { initialARUniversityEntryRequestFilter } from "../../../../init/initRequests";

const arUniRequestFilterSlice = createSlice({
  name: "ARUniRequestFilterSlice",
  initialState: initialARUniversityEntryRequestFilter,
  reducers: {
    updateFilter: (state, action) => {
      const filterValues = { ...action.payload };
      return filterValues;
    },
    clearFilter: (state) => {
      return {
        ...initialARUniversityEntryRequestFilter,
        pageSize: state.pageSize,
        order: state.order,
        orderBy: state.orderBy,
      };
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    changeOrderBy: (state, action) => {
      const currentOrderBy = state.orderBy;

      if (currentOrderBy === action.payload && state.order === "desc") {
        state.order = "asc";
      } else if (currentOrderBy === action.payload && state.order === "asc") {
        state.order = "desc";
      } else {
        state.order = initialARUniversityEntryRequestFilter.order;
      }
      state.orderBy = action.payload;
    },
  },
});

export const { updateFilter, clearFilter, changePageSize, changeOrderBy, changePage } = arUniRequestFilterSlice.actions;
export default arUniRequestFilterSlice.reducer;
